<template>
  <div>
    <v-container class="pa-0" fluid>
      <v-row style="height: 48px; max-height: 48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Imprime las Comisiones a Pagar a los Vendedores.'"
          :show-absolute="false"
          :titulo="'Reporte Comisiones de Vendedores por Cobro'"
          @MethodAnular="anular"
          @MethodEliminar="remove"
          @MethodGuardar="save"
          @MethodImprimir="imprimirList"
          @MethodNuevo="newwnuevo"
        />
      </v-row>

      <v-row>
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <v-col :max-height="this.windowSize.height - 96">
          <v-app
            id="inspire"
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }"
          >
            <ComisionesVendedoresComun
              v-if="!this.$store.getters.GetConfiguracionGeneral.config.distribuidoraFarmaceutico"
            />
            <ComisionesVendedoresFarmaceutica v-else />
          </v-app>
        </v-col>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
      </v-row>
    </v-container>

    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      v-model="acti_tb_data"
      label="myAlert"
      max-height="100%"
      max-width="100%"
      persistent
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar color="#BDBDBD" flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>
          <v-toolbar-title class="font-weight-light">REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i class="fa fa-close" style="font-size: 20px; color: #dd4b39"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" hide-details label="Buscar" single-line @keyup="filtro">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="slotHtabla" :items="list" :search="search" dense @click:row="datostabla">
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import { EventBus } from "../../event-bus"
  import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
  import ContenidoBase from "../../components/ContenidoBase"
  import ModalReporteFiltros from "../../components/ModalReporteFiltros"
  import { fechaNueva } from "@/js/Funciones.js"
  import ComisionesVendedoresComun from "@/Reportes/cxc/ComisionesVendedoresComun.vue"
  import ComisionesVendedoresFarmaceutica from "@/Reportes/cxc/ComisionesVendedoresFarmaceutica.vue"

  export default {
    components: {
      ComisionesVendedoresFarmaceutica,
      ComisionesVendedoresComun,
      BarraBusqueda2,
      ContenidoBase,
      ModalReporteFiltros,
    },

    created() {
      var json = {
        titulo: "Reporte Comisiones de Vendedores por Cobro",
        descripcion: "Imprime las Comisiones a Pagar a los Vendedores.",
        save: false,
        eliminar: false,
        anular: false,
        nuevo: false,
        imprimir: false,
        accion: [
          "ReporteComisionesVendedoresNew",
          "ReporteComisionesVendedoresSave",
          "ReporteComisionesVendedoresRemove",
          "ReporteComisionesVendedoresAnular",
          "ReporteComisionesVendedoresPrintList",
        ],
      }
      EventBus.$emit("anularBotonesAccion", json)
    },

    mounted() {
      EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
      // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
      EventBus.$on("ReporteComisionesVendedoresNew", this.new)
      EventBus.$on("ReporteComisionesVendedoresSave", this.save)
      EventBus.$on("ReporteComisionesVendedoresRemove", this.remove)
      EventBus.$on("ReporteComisionesVendedoresAnular", this.remove)
      EventBus.$on("ReporteComisionesVendedoresPrintList", this.imprimirList)
      EventBus.$on("emitReporteComisionesVendedores", this.datostabla)
      EventBus.$on("onResize", this.onResize)
    },

    data: () => ({
      windowSize: { width: "auto", height: "auto" },
      ComisionesVendedores: {
        nombre: "Reporte Comisiones de Vendedores por Cobro",
        UrlImprimir: "/reportescxc/ImprimirComisionesVendedores",
        UrlExel: "/reportescxc/ExcelComisionesVendedores",
        UrlCorreo: "/reportescxc/CorreoComisionesVendedores",
        desde: fechaNueva(),
        hasta: fechaNueva(),
        cliente: null,
        vendedor: null,
        tipocliente: null,
      },

      EstadoBtn: {
        BarraTablaDinamicaAprir: false,
        nuevo: false,
        guardar: false,
        eliminar: false,
        anular: false,
        imprimir: false,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

      text: "",

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" },
      ],

      list: [],
      search: "",
      acti_tb_data: false,

      aalert: {
        estado: false,
        color: null,
      },
    }),

    methods: {
      onResize(e) {
        this.windowSize = e
      },

      datostabla(e) {
        this.ComisionesVendedores = e
        this.acti_tb_data = false
      },
      save() {},
      remove() {},
      eliminar() {},
      anular() {},
      imprimirList() {},
      //Retorna los objectos del componente ModalReporteFiltros
      DDataReporteBasico() {},

      newwnuevo() {
        ;(this.ComisionesVendedores = {
          activo: true,
          borrado: false,
          codigo: 0,
          descripcion: "",
          descripcionOriginal: "",
          fechaCreacion: "",
          fechaModificacion: "",
          usuarioCreacion: "",
          usuarioModificacion: "",
        }),
          EventBus.$emit("actualizaBarraBusqueda2")
      },

      alerta(e, l) {
        if (l == "bien") {
          this.aalert.estado = true
          this.aalert.color = "success"
          this.aalert.nombre = e
          this.newwnuevo()
        }

        if (l == "error") {
          this.aalert.estado = true
          this.aalert.color = "error"
          this.aalert.nombre = e
          this.ejecucion = false
        }
      },

      async filtro() {
        await this.$axios
          .post(this.$hostname + this.$hName + "/services/tipocliente/findalltipoclientes", {
            usuario: JSON.parse(JSON.stringify(this.$user)),
          })
          .then((res) => {
            this.list = res.data
          })
      },
    },
  }
</script>

<style></style>
